import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import {
  RadioField,
  SimpleSelectField,
} from '@unite-us/app-components';
import formatOptions from 'common/utils/formatOptions';

const getFieldError = (meta) => (meta.touched && meta.error ? meta.error : undefined);

const visibilityClass = (isVisible) => (isVisible ? '' : 'hidden');

function MilitaryDisabilityProofFields({ militaryEnums, hasDisabilityRating, hasProof }) {
  return (
    <>
      <div className="form-group">
        <div className="control-label">Has VA-rated Service-Connected Disability?</div>
        <Field name="service_connected_disability">
          {({ input, meta }) => (
            <RadioField
              id="connected-disability"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.connected_disability)}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
      <div className={visibilityClass(hasDisabilityRating)}>
        <Field name="service_connected_disability_rating">
          {({ input, meta }) => (
            <SimpleSelectField
              id="disablility-rating"
              label="Service-Connected Disability Rating"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.disability_rating)}
              optionSettings={{ labelKey: 'label', valueKey: 'value' }}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
      <div className="form-group">
        <div className="control-label">Proof of veteran status?</div>
        <Field name="proof_of_veteran_status">
          {({ input, meta }) => (
            <RadioField
              id="proof"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.proof_of_veteran_status)}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
      <div className={visibilityClass(hasProof)}>
        <Field name="proof_type">
          {({ input, meta }) => (
            <SimpleSelectField
              id="proof-type"
              label="Proof Type"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.proof_type)}
              optionSettings={{ labelKey: 'label', valueKey: 'value' }}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
    </>
  );
}

MilitaryDisabilityProofFields.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  hasDisabilityRating: PropTypes.bool.isRequired,
  hasProof: PropTypes.bool.isRequired,
};

export default MilitaryDisabilityProofFields;
